import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Dp from "../../assets/dp.png";
import iFile from "../../assets/i-file.svg";
import ifileNotFound from "../../assets/i-fileNotFound.svg";
import leftArrow from "../../assets/i-left-arrow.svg";
import rightArrow from "../../assets/i-right-arrow.svg";
import iStreaming from "../../assets/i-streaming.svg";
import iVideo from "../../assets/i-video.svg";
import "./Courses.css";
import DaysLeft from "../../components/DaysLeft";
const quizeUrl = process.env.REACT_APP_QUIZE_URL;

const Courses = ({ setCartItemCount, setIsLoading }) => {
  const [lessons, setLessons] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [monthNames, setMonthNames] = useState([]);
  const [quota_id, setQuotaId] = useState(null);
  // const [year, setYear] = useState(new Date().getFullYear());
  const [year, setYear] = useState(2025);
  const [isPaid, setIsPaid] = useState(false);
  const [isExpired, setIsExpired] = useState(true);

  const [isInCart, setIsInCart] = useState(false);

  const { course_id } = useParams();
  const navigate = useNavigate();

  const apiBase = process.env.REACT_APP_API;

  useEffect(() => {
    const fetchQuota = async () => {
      try {
        setIsLoading(true);
        const response = await fetch(
          `${apiBase}/courses/getquota?course_id=${course_id}&showHide=false`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        const data = await response.json();
        setMonthNames(data);

        if (data.length > 0) {
          setQuotaId(data[data.length - 1].quota_id);
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setIsLoading(false);
      }
    };
    fetchQuota();
  }, [course_id, apiBase]);

  useEffect(() => {
    if (!quota_id) return;
    const fetchLessons = async () => {
      try {
        setIsLoading(true);
        const token = localStorage.getItem("token");
        const response = await fetch(
          `${apiBase}/courses/lessons?course_id=${course_id}&quota_id=${quota_id}`,
          {
            headers: {
              Authorization: `${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        if (!response.ok) {
          throw new Error("Server error");
        }
        const data = await response.json();
        setLessons(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
        setIsLoading(false);
      }
    };

    fetchLessons();
  }, [quota_id, course_id, apiBase, setIsLoading]);

  const handleMonthClick = (mon) => {
    setQuotaId(mon);
  };

  const handleYearClick = (year) => {
    setYear(year);
  };

  const handleBuyNowClick = (course_id, quota_id, year) => {
    const cartItem = { course_id, quota_id, year };
    localStorage.setItem("cartItems", JSON.stringify(cartItem));
    navigate("/cart");
    setCartItemCount(1);
  };

  const formatDateTime = (isoString) => {
    const date = new Date(isoString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;

    return `${year}/${month}/${day} | ${hours}:${minutes}${ampm}`;
  };

  useEffect(() => {
    const fetchIsUserPaid = async () => {
      try {
        console.log(year);
        const token = localStorage.getItem("token");
        if (!token) return;

        const response = await fetch(
          `${apiBase}/courses/checkifuserhaspaidformonth`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json", // Add this line
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              course_id: course_id,
              quota_id: quota_id,
            }),
          }
        );

        if (response.ok) {
          const data = await response.json();
          if (data.status == 200) {
            setIsPaid(true);
          }
        } else {
          setIsPaid(false);
        }
      } catch (error) {
        setError(error);
      }
    };

    fetchIsUserPaid();
  }, [quota_id, year, course_id]);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;

  console.log("quota : ", quota_id);
  console.log("lessons : ", lessons.courseDetails[0]);

  return (
    <div className="px-3 sm:px-10 sm:mt-20 pt-20 flex flex-col items-center mb-20">
      <div className="flex w-full  items-start mb-10">
        <Link to="/courses" className="flex">
          <h1 className="flex flex-row items-center text-2xl opacity-50 font-medium uppercase hover:underline">
            <img src={leftArrow} alt="back-arrow" className="size-8" />
            <p>Back to Courses</p>
          </h1>
        </Link>
      </div>
      <div className="flex flex-col md:flex-row w-full">
        <div className="w-full md:w-4/12 lg:w-3/12">
          <div className="px-8 pt-4 flex flex-col">
            <h2 className="text-myBlack font-bold text-xl text-right">
              {lessons.courseDetails?.[0]?.title || "Course Title"}
            </h2>
            <h3 className="text-myBlue font-bold text-lg text-right">
              {lessons.courseDetails?.[0]?.subject} |{" "}
              {lessons.courseDetails?.[0]?.batch}
            </h3>
            <h3 className="uppercase font-medium text-right text-xs text-gray-300">
              {lessons.courseDetails?.[0]?.quota}
            </h3>
          </div>
          <div className="my-4 flex flex-col px-8">
            <img
              src={lessons.courseDetails?.[0]?.dp || Dp}
              alt="Course Display"
            />
            <h1 className="font-semibold text-xl mt-4">Teachers:</h1>
            <h3 className="font-semibold ml-4 opacity-50">Janith Miyuranga</h3>
            <h3 className="font-semibold ml-4 opacity-50">Nawod Dilshan</h3>
          </div>
          <hr className="my-4" />
          <div className="mx-8 bg-myBlue rounded-xl px-2 py-3 mb-10">
            <h1 className="font-bold text-center text-2xl text-myWhite">
              LKR {lessons.courseDetails?.[0]?.amount || "0.00"}
            </h1>
          </div>
        </div>

        {/* ---------------------   */}

        <div className=" w-full md:w-8/12 lg:w-9/12">
          <div className="flex flex-row flex-wrap justify-between">
            <ul className="flex flex-row space-x-2">
              <li key={year} onClick={() => handleYearClick(year)}>
                <button className="bg-myBlue opacity-50 shadow-sm active:opacity-100 hover:opacity-100  text-white p-2 font-black">
                  {year}
                </button>
                <hr className="my-4 " />
              </li>
            </ul>
            <ul className="month grid grid-cols-3 md:grid-cols-6">
              {monthNames.map((mon) => (
                <li
                  key={mon.quota_id}
                  onClick={() => {
                    handleMonthClick(mon.quota_id);
                  }}
                >
                  <button
                    className={`bg-myBlue shadow-sm active:opacity-100 hover:opacity-100 mr-2 text-white p-2 font-black ${
                      mon.quota_id == quota_id ? "opacity-100" : "opacity-50"
                    }`}
                  >
                    {mon.title}
                  </button>
                  <hr className="my-4" />
                </li>
              ))}
            </ul>
          </div>

          {/* purches card */}
          {(!isPaid || isExpired) && (
            <div className="border py-2 pr-2 rounded-md bg-opacity-60 w-full space-x-4 flex flex-row justify-end items-end ">
              <button
                onClick={() => {
                  handleBuyNowClick(course_id, quota_id, year);
                }}
                className="bg-myRed text-white text-base font-semibold py-2 px-4 rounded-md hover:bg-opacity-90"
              >
                Buy Now
              </button>
            </div>
          )}
          {isPaid && (
            <div className="border py-2 pr-2 rounded-sm bg-opacity-60 w-full space-x-4 flex flex-row justify-end items-end">
              <DaysLeft
                course_id={course_id}
                quota_id={quota_id}
                isExpired={isExpired}
                setIsExpired={setIsExpired}
              />
            </div>
          )}
          <div className="flex flex-col items-end mb-5 mt-10 ">
            <h1 className="text-xl font-bold text-gray-500 w-fit uppercase">
              Resources
              <hr />
            </h1>
          </div>
          {lessons.pdfs.length > 0 ? (
            <ul className="grid grid-cols-1 md:grid-cols-2 gap-2 ">
              {lessons.pdfs.map((lesson, index) => (
                <li key={index}>
                  {isPaid && !isExpired ? ( // Check if isPaid is true
                    <a
                      href={lesson.URL}
                      target="_blank"
                      className="flex flex-row items-center justify-between shadow-sm border my-1 pl-3 pr-3 py-2 rounded-md"
                      rel="noopener noreferrer"
                    >
                      <div className="flex flex-row space-x-3 items-center">
                        <img
                          src={iFile}
                          alt="icon-file"
                          className="size-8 text-myBlue"
                        />
                        <div className="">
                          <h1 className="font-semibold text-xl">
                            {lesson.title}
                          </h1>
                          <p className="font-semibold text-sm text-gray-400">
                            Uploaded: {formatDateTime(lesson.date)}
                          </p>
                        </div>
                      </div>
                      <img
                        src={rightArrow}
                        alt="right-arrow"
                        className="size-6"
                      />
                    </a>
                  ) : (
                    <div className="flex flex-row items-center justify-between shadow-sm border my-1 pl-3 pr-3 py-2 rounded-md">
                      <div className="flex flex-row space-x-3 items-center">
                        <img
                          src={iFile}
                          alt="icon-file"
                          className="size-8 text-myBlue"
                        />
                        <div className="">
                          <h1 className="font-semibold text-xl">
                            {lesson.title}
                          </h1>
                          <p className="font-semibold text-sm text-gray-400">
                            Uploaded: {formatDateTime(lesson.date)}
                          </p>
                        </div>
                      </div>
                      <img
                        src={rightArrow}
                        alt="right-arrow"
                        className="size-6"
                      />
                    </div>
                  )}
                </li>
              ))}
            </ul>
          ) : (
            <p className="p-5 italic font-medium text-gray-500 text-center flex flex-col justify-center items-center space-x-2">
              <img
                src={ifileNotFound}
                alt="i-fileNotFound"
                className="size-8 opacity-50"
              />
              <span>No pdf files available at the moment.</span>
            </p>
          )}

          <hr className="mt-5" />
          <div className="flex flex-col items-end mb-5 mt-10 ">
            <h1 className="text-xl font-bold text-gray-500 w-fit uppercase">
              Videos
              <hr />
            </h1>
          </div>

          {lessons.videos.length > 0 ? (
            <ul className="grid grid-cols-1 lg:grid-cols-2 gap-2">
              {lessons.videos.map((lesson, index) => (
                <li
                  key={index}
                  className="flex flex-col items-end justify-between w-full shadow-sm border my-1 pl-3 pr-3 py-6 rounded-md"
                >
                  <div className="flex flex-row space-x-3 w-full ml-1">
                    <img
                      src={iVideo}
                      alt="icon-file"
                      className="size-16 text-myBlue"
                    />
                    <div>
                      <h1 className="font-semibold text-2xl">{lesson.title}</h1>
                      <p className="font-semibold text-sm text-gray-400">
                        Uploaded: {formatDateTime(lesson.date)}
                      </p>
                    </div>
                  </div>
                  <div className="flex flex-row justify-between items-center w-full mt-4">
                    <button className="flex flex-row items-center space-x-1 opacity-50">
                      <img
                        src={iStreaming}
                        alt="i-streaming"
                        className="size-4"
                      />
                      <p className="text-sm font-bold">Web Player</p>
                    </button>

                    {isPaid && !isExpired ? (
                      <Link
                        to={
                          lesson?.isDriveVideo == 0
                            ? `/video/${lesson.lesson_id}`
                            : `/driveplayer?id=${lesson.lesson_id}`
                        }
                      >
                        <button className="text-white bg-myBlue hover:bg-myPurple focus:ring-2 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-8 py-2.5 text-center flex justify-center items-center">
                          Attend
                        </button>
                      </Link>
                    ) : (
                      <span className="text-white bg-myRed cursor-not-allowed font-medium rounded-lg text-sm px-8 py-2.5 text-center flex justify-center items-center">
                        Purchase to acces
                      </span>
                    )}
                  </div>
                </li>
              ))}
            </ul>
          ) : (
            <p className="p-5 italic font-medium text-gray-500 text-center flex flex-col justify-center items-center space-x-2">
              <img
                src={ifileNotFound}
                alt="i-fileNotFound"
                className="size-8 opacity-50"
              />
              <span>No videos available at the moment.</span>
            </p>
          )}

          {lessons.quizzes && lessons.quizzes.length > 0 ? (
            <div className="flex flex-col items-end mb-5 mt-10 ">
              <h1 className="text-xl font-bold text-gray-500 w-fit uppercase">
                Quizzes
                <hr />
              </h1>
              <ul className="grid grid-cols-1 lg:grid-cols-2 gap-2  w-full">
                {lessons.quizzes.map((quiz, index) => (
                  <li
                    key={index}
                    className="flex flex-col items-end justify-between w-full shadow-sm border my-1 pl-3 pr-3 py-6 rounded-md"
                  >
                    <div className="flex flex-row space-x-3 w-full ml-1">
                      <img
                        src={iVideo}
                        alt="icon-file"
                        className="size-16 text-myBlue"
                      />
                      <div>
                        <h1 className="font-semibold text-2xl">{quiz.title}</h1>
                        <p className="font-semibold text-sm text-gray-400">
                          Uploaded: {formatDateTime(quiz.created_at)}
                        </p>
                      </div>
                    </div>
                    <div className="flex flex-row justify-between items-center w-full mt-4">
                      {isPaid && !isExpired ? (
                        <a
                          href={`${quizeUrl}/quize?quiz_id=${
                            quiz.quiz_id
                          }&token=${localStorage.getItem("token")}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <button className="text-white bg-myBlue hover:bg-myPurple focus:ring-2 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-8 py-2.5 text-center flex justify-center items-center">
                            Start Quiz
                          </button>
                        </a>
                      ) : (
                        <span className="text-white bg-myRed cursor-not-allowed font-medium rounded-lg text-sm px-8 py-2.5 text-center flex justify-center items-center">
                          Purchase to access
                        </span>
                      )}
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          ) : (
            <p className="p-5 italic font-medium text-gray-500 text-center"></p>
          )}
        </div>
      </div>

      {/* ---------------------   */}
    </div>
  );
};

export default Courses;
